import type { EventType, HtmlType } from '../../types.js'
import type { TsCodeType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { LeafBlock } from '../leaf-block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { Expression } from '../../data/text-or-code.js'
import { Parameter } from '../../script/parameter.js'

@jsonClass('PdfBlock')
export class PdfBlock extends LeafBlock {
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'URL',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: (blocks) =>
			(blocks[0] as PdfBlock).contentBase64Code ? false : '(*)',
	})
	urlCode: TsCodeType = ''

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'code',
		order: 2,
		label: 'Base64 content',
		codeLanguage: 'ts',
		tsReturnType: () => 'string | ArrayBuffer',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: (blocks) => ((blocks[0] as PdfBlock).urlCode ? false : '(*)'),
	})
	contentBase64Code: TsCodeType = ''

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'code',
		order: 3,
		label: 'Height',
		codeLanguage: 'ts',
		tsReturnType: () => 'string | number',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
	})
	heightCode: TsCodeType = `'80vh'`

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 4,
		label: 'Redaction mode',
		codeLanguage: 'ts',
		tsReturnType: () => 'boolean',
		editorSize: 'singleline',
		isBinding: false,
	})
	redactionModeCode = new Expression('')

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 4,
		label: 'Redactions binding',
		codeLanguage: 'ts',
		tsReturnType: () => 'any[][]',
		editorSize: 'singleline',
		isBinding: true,
	})
	redactionBindingCode = new Expression('')

	constructor(init: Partial<PdfBlock> = {}) {
		super()
		this.exampleText = 'PDF'
		this.init(init)
	}

	get allowedEventTypes(): EventType[] {
		return [
			{
				name: 'redactionsChanged',
				parameters: [
					new Parameter({
						name: 'redactions',
						type: '{ x1: number, y1: number, x2: number, y2: number }[][]',
						defaultExpression: '$event',
					}),
				],
			},
		]
	}

	producePreview(): HtmlType {
		return `<div style="background: #dddddd; border: 1px solid #bbbbbb; padding: 3em;">${this.transpileExpressionForHtml(this.exampleText)}</div>`
	}
}
